function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M60 0C26.9343 0 0 26.8918 0 60.0274C0 93.1082 26.9343 120 60 120C93.0657 120 120 93.0534 120 59.9726C119.945 26.8918 93.0657 0 60 0ZM60 111.785C31.4234 111.785 8.21168 88.5623 8.21168 60.0274C8.21168 31.4925 31.4234 8.21543 60 8.21543C88.5766 8.21543 111.788 31.4377 111.788 60.0274C111.734 88.5623 88.5219 111.785 60 111.785Z",
  fill: "#88BB1B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.9645 41.4061C83.3769 41.4608 81.9536 42.1729 80.8587 43.323L53.8149 71.8032L38.9791 58.2203C36.5704 56.0295 32.793 56.1938 30.6032 58.6037C29.5083 59.7539 28.9609 61.2874 29.0704 62.8757C29.1251 64.464 29.8368 65.9428 30.9864 66.9834L49.928 84.3454C51.1324 85.4408 52.6105 85.9885 54.1434 85.9885C55.6215 85.9885 57.0448 85.4408 58.1397 84.4001C58.4134 84.1811 58.6324 83.962 58.8514 83.7429L89.5631 51.4289C90.658 50.2787 91.2054 48.7452 91.0959 47.1569C91.0412 45.5686 90.3295 44.0898 89.1799 43.0492C88.0302 41.899 86.5521 41.3513 84.9645 41.4061Z",
  fill: "#88BB1B"
});

const SvgSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.86c35de2.svg";
export { ForwardRef as ReactComponent };